import { useEffect, useState } from "react"
import { DOMAIN_PARTNER_MAP } from "../constants/partner"
import { type PartnerKey } from "../types/partnerKey"

export function usePartnerFromDomain(): PartnerKey {
    const [partner, setPartner] = useState<PartnerKey>("default")

    useEffect(() => {
        const host = window.location.hostname
        const match = Object.entries(DOMAIN_PARTNER_MAP).find(([domain]) => host.includes(domain))

        if (match) setPartner(match[1])
    }, [])

    return partner
}
